export var shortenString = function shortenString(text) {
  if (text.length >= 12) {
    return "".concat(text.substr(0, 5), "...").concat(text.substr(-5));
  }

  return text;
};